export const isDateBeforeToday = (date) => {
    if (!date) return null;
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const inputDate = new Date(date);
    inputDate.setHours(0, 0, 0, 0);
    return inputDate.getTime() < currentDate.getTime();
};

export const dateFormat = (date) => {
    const inputDate = new Date(date);

    const day = inputDate.getDate().toString().padStart(2, "0");
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0"); // Adding 1 because months are zero-based
    const year = inputDate.getFullYear();

    return `${day}/${month}/${year}`;
};


export const dateTimeFormat = (timeString) => {
    if (!timeString) return "";

    const timePart = String(timeString).trim().includes(" ")
        ? String(timeString).trim().split(" ").pop()
        : String(timeString).trim();
    const [hours, minutes] = timePart.split(":").map(Number);

    if (!Number.isFinite(hours) || !Number.isFinite(minutes)) {
        return "";
    }

    // Determine if it's AM or PM
    const period = hours >= 12 ? 'PM' : 'AM';
  
    // Convert hours to 12-hour format
    const formattedHours = hours % 12 || 12;
  
    // Add leading zeros if necessary
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  
    // Return the formatted time
    return `${formattedHours}:${formattedMinutes} ${period}`;
    

};

export const getCurrentDate = () => {
    const currentDate = new Date();

    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
};
